const Language = {
    CHINESE: "zh",
    ENGLISH: "en",
    MELAYU: "my",
}

export default Language;
